import { createTestIds } from '@duke-hq/lib/createTestId';

export const testIds = createTestIds('apps-admin-web-UnitsOfCompetency-UnitGeneration-components', [
  'nonAccreditedTab',
  'autoAssessSwitch',
  'limitSectionsSwitch',
  'sectionCountInput',
  'backButton',
  'continueButton',
  'generateButton',
  'fetchError',
  'validationMessage',
  'deleteElementButton',
  'addElementButton',
  'addCriterionButton',
  'sectionCard',
  'requirementChip',
  'allocateRequirementsButton',
  'requirementOption',
  'removeCastButton',
  'addCastButton',
  'coverageWarning',
  'saveAndContinueButton',
  'runMessage',
  'coverageBlockers',
  'coverageClean',
  'continueGenerationButton',
  'coverageQuestionHeader',
  'coverageDot',
  'coverageProblem',
  'workplaceSwitch',
  'workedExampleStory',
  'caseStudyStory',
  'supportingOption',
  'addSectionButton',
  'deleteSectionButton',
]);
